import { LayoutSetup, StepItemsList } from "@/components/setup/layout-setup";
import { useAdminMode } from "@/contexts/admin-mode-provider";
import { useTeams } from "@/contexts/teams-provider";
import { useTranslation } from "@/hooks/useTranslation";
import { redirectTo } from "@/lib/location";
import { useMemo } from "react";
import { SetupTrialEndedIntroductionPage } from "./trial-ended/0-introduction";
import { SetupTrialEndedPaymentMethodPage } from "./trial-ended/1-payment-method";
import { SetupTrialEndedFinishPage } from "./trial-ended/2-finish";

export const SetupTrialEndedPage = () => {
  const { teamSelected, isUser } = useTeams();
  const { isAdminMode } = useAdminMode();
  const { t } = useTranslation();

  if (!(teamSelected?.trialEndsAt && !isUser && !isAdminMode)) {
    redirectTo("/");
    return;
  }

  const isBillingEnabled = teamSelected?.billingEnabled !== false;

  const steps: StepItemsList = useMemo(() => {
    const baseSteps: StepItemsList = [
      {
        id: "introduction",
        label: t("setup.trialEnded.steps.introduction"),
        element: <SetupTrialEndedIntroductionPage />,
      },
    ];

    if (isBillingEnabled) {
      baseSteps.push({
        id: "payment-method",
        label: t("setup.trialEnded.steps.paymentMethod"),
        element: <SetupTrialEndedPaymentMethodPage />,
      });
    }

    baseSteps.push({
      id: "finish",
      label: t("setup.trialEnded.steps.finish"),
      element: <SetupTrialEndedFinishPage />,
    });

    return baseSteps;
  }, [t, isBillingEnabled]);

  return <LayoutSetup steps={steps} />;
};
